import { render, staticRenderFns } from "./MetadataCollectionWorkList.vue?vue&type=template&id=4d5aecb2&"
import script from "./MetadataCollectionWorkList.vue?vue&type=script&lang=js&"
export * from "./MetadataCollectionWorkList.vue?vue&type=script&lang=js&"
import style0 from "./MetadataCollectionWorkList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MetadataCollectionWorkList.vue"
export default component.exports